import { render, staticRenderFns } from "./washcustomerlist.vue?vue&type=template&id=6d11bf1c&"
import script from "./washcustomerlist.vue?vue&type=script&lang=js&"
export * from "./washcustomerlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports